import React, { Component } from 'react';

import RedirectableRequestOuterList from './RedirectableRequestOuterList';

class RedirectableTopicOuter extends Component {

  static defaultProps = {
    topicName : "UNDEFINED",
    requests : null,
  }

  state = {
    isExpand : false,
  }

  handleExpandBtnOnClick = (e) => {
    const {isExpand} = this.state;
    this.setState({
      isExpand : !isExpand,
    })
  }

  renderRequests = (redirectableRequests) => {
    const {isExpand} = this.state;
    const { updateResponseRedirect } = this.props;
    if (isExpand) {
      return (
        <RedirectableRequestOuterList 
          requests={redirectableRequests}
          updateResponseRedirect={updateResponseRedirect} />
      );
    }
  }

  render() { 
    const { renderRequests } = this;
    const { handleExpandBtnOnClick } = this;

    const { topicName } = this.props;
    const { requests } = this.props;

    const renderedRequests = renderRequests(requests);

    return (
      <li className="redirectable-topic"
        onClick={handleExpandBtnOnClick}>
        <p>
          <span className="topic-name"> {topicName} </span>
          <span className="fix-text"> 토픽 </span>
        </p>
        {renderedRequests}
      </li>
    );
  }
}
 
export default RedirectableTopicOuter;